import { FlightBrand } from '@ibe/models';

export class Brand {
	name: string;
	price: number;
	bookAwardValue?: string;
	state?: 'available' | 'sold out' | 'not available';
	recommended?: boolean;
	economyxtra?: boolean;
	features?: 'all' | [];
}

const HAND_BAGGAGE = {
	label: 'Hand baggage',
	order: 3,
	type: 'added',
	description: '1x 8kg allowed',
	icon: 'luggage--cabin_trolley',
	id: 'bags',
	details: { label: 'Learn more', route: 'details-hand_luggage' },
	flight_details: { label: 'Learn more', route: 'flight-details-hand_luggage' }
};
export const DIGITAL_KIOSK = {
	label: 'Digital Kiosk',
	type: 'added',
	details: { label: 'Learn more', route: 'details-kiosk' },
	icon: 'leisure_and_commodities--magazines',
	flight_details: { label: 'Learn more', route: 'details-kiosk' },
	id: 'kiosk'
};
const SPORTS_EQUIPMENT = {
	id: 'sports',
	label: 'Sports Equipment',
	type: 'added',
	details: { label: 'Learn more', route: 'sports-equipment' },
	icon: 'ancillaries--sports_equipment'
};
const MUSICAL_EQUIPMENT = {
	id: 'instruments',
	label: 'Musical Equipment',
	type: 'added',
	details: { label: 'Learn more', route: 'musical-equipment' },
	icon: 'luggage--music_equipment'
};
const PREMIUM_CUSTOMER_CENTRE = {
	label: 'Premium Customer Centre',
	type: 'added',
	order: 9,
	details: { label: 'Learn more', route: 'premium-customer-centre' },
	icon: 'support--premium_customer_service',
	flight_details: { label: 'Learn more', route: 'flight-details-premium-customer-centre' },
	id: 'premium-customer-centre'
};
const PREMIUM_BOARDING = {
	label: 'Premium Boarding',
	type: 'added',
	order: 10,
	details: { label: 'Learn more', route: 'premium-boarding' },
	icon: 'airport--differentiated_boarding',
	flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
	id: 'differentiated-boarding'
};
const PRIORITY_CHECK_IN = {
	label: 'Priority Check In',
	type: 'added',
	order: 11,
	details: { label: 'Learn more', route: 'priority-checkin' },
	icon: 'check-in--priority',
	flight_details: { label: 'Learn more', route: 'flight-details-priority-checkin' },
	id: 'priority-checkin'
};
const PETS = {
	id: 'pets',
	label: 'Pets',
	type: 'added',
	details: { label: 'Learn more', route: 'pets' },
	icon: 'luggage--small_pets'
};
const PRIORITY_BAGGAGE = {
	id: 'priority-baggage',
	label: 'Priority baggage',
	description: '1x 23kg allowed',
	type: 'added',
	icon: 'luggage--priority',
	details: { label: 'Learn more', route: 'details-priority-luggage' },
	flight_details: { label: 'Learn more', route: 'flight-details-priority-luggage' }
};
const CHECKED_BAGGAGE = {
	id: 'checked-baggage',
	label: 'Checked baggage',
	order: 4,
	description: '1x 23kg allowed',
	type: 'added',
	icon: 'ancillaries--luggage',
	details: { label: 'Learn more', route: 'details-luggage' },
	flight_details: { label: 'Learn more', route: 'flight-details-luggage' }
};
const DETAILS_LOUNGE = {
	id: 'lounge',
	label: 'Lounge access',
	description: 'Free to access lounge for all passengers',
	type: 'added',
	order: 7,
	details: { label: 'Learn more', route: 'details-lounge' },
	icon: 'ancillaries--lounge',
	flight_details: { label: 'Learn more', route: 'flight-details-lounge' }
};
const NO_PREMIUM_FEATURES = [
	{
		label: 'Premium Customer Centre',
		type: 'unavailable',
		order: 9,
		icon: 'support--premium_customer_service',
		flight_details: { label: 'Learn more', route: 'flight-details-premium-customer-centre' },
		id: 'premium-customer-centre'
	},
	{
		label: 'Premium Boarding',
		type: 'unavailable',
		order: 10,
		icon: 'airport--differentiated_boarding',
		flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
		id: 'differentiated-boarding'
	},
	{
		label: 'Priority Check In',
		type: 'unavailable',
		order: 11,
		icon: 'check-in--priority',
		flight_details: { label: 'Learn more', route: 'flight-details-priority-checkin' },
		id: 'priority-checkin'
	}
];
const DETAILS_NO_LOUNGE = {
	label: 'Lounge access',
	type: 'available',
	description: 'from 25€',
	price: 25,
	order: 7,
	id: 'lounge',
	icon: 'ancillaries--lounge',
	flight_details: { label: 'Learn more', route: 'flight-details-lounge' }
};
export const PASSENGER_INCLUDED_EXTRAS = [
	DIGITAL_KIOSK,
	PETS,
	SPORTS_EQUIPMENT,
	MUSICAL_EQUIPMENT
];
export const PASSENGER_INCLUDED_LINKS = [
	DIGITAL_KIOSK,
	PETS,
	SPORTS_EQUIPMENT,
	MUSICAL_EQUIPMENT,
	{
		label: 'José Simões is a GOLD Member',
		cssClass: 'hide-on-print',
		description: '',
		type: 'added',
		secondary: false,
		secondary_on_mobile: false,
		icon: null,
		included: { label: 'View all benefits' }
	},
	{
		label: '',
		cssClass: 'hide-on-print',
		description: '',
		type: 'added',
		secondary: false,
		secondary_on_mobile: false,
		icon: null,
		included: {
			label: 'See what′s included per passenger'
		}
	}
];
export const DEFAULT_FEATURES = [
	{
		label: 'Miles',
		order: 2,
		description: 'For Miles&GO members only',
		type: 'added',
		details: { label: 'Learn more', route: 'details-loyalty_miles' },
		icon: 'loyalty--miles',
		flight_details: { label: 'Learn more', route: 'flight-details-miles' },
		id: 'miles'
	},
	HAND_BAGGAGE,
	{
		label: 'Meal',
		description: 'May include dairy and other allergens',
		type: 'added',
		icon: 'ancillaries--meals',
		details: { label: 'Learn more', route: 'details-meals' }
	},
];
export const ECONOMY_EXTRAS_SECONDARY_FEATURES = [
	{
		label: 'Lounge from 15,00€',
		description: 'from 15€',
		type: 'extra',
		price: 15,
		secondary: false,
		secondary_on_mobile: true,
		action: { label: 'add', route: 'ancillaries--lounge' },
		icon: 'ancillaries--lounge',
		name: 'Lounge',
		id: 'lounge'
	},
	{
		label: 'Sports equipment from 20,00€',
		description: 'From 20,00€',
		type: 'extra',
		price: 20,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'Choose', route: 'ancillaries--sports_equipment' },
		icon: 'ancillaries--sports_equipment',
		name: 'Sports equipments',
		id: 'sports'
	},
	{
		label: 'Music instruments from 20,00€',
		description: 'From 20,00€',
		type: 'extra',
		price: 20,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'Choose', route: 'ancillaries--music-instruments' },
		icon: 'luggage--music_equipment',
		name: 'Music instruments',
		id: 'instruments'
	},
	{
		label: 'Small pets from 35,00€',
		description: 'From 35,00€',
		type: 'extra',
		price: 35,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'Choose', route: 'ancillaries--small-pets' },
		icon: 'luggage--small_pets',
		name: 'Small pets',
		id: 'pets'
	},
	{
		label: 'Special meals for free',
		description: 'Free for people with food restrictions',
		type: 'extra',
		price: 0,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'choose', route: 'ancillaries--special-meals' },
		icon: 'ancillaries--special_meals',
		name: 'meals',
		id: 'meals'
	}
];
export const BUSINESS_EXTRAS_SECONDARY_FEATURES = [
	{
		label: 'Sports equipment from 20,00€',
		description: 'From 20,00€',
		type: 'extra',
		price: 20,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'Choose', route: 'ancillaries--sports_equipment' },
		icon: 'ancillaries--sports_equipment',
		name: 'Sports equipments',
		id: 'sports'
	},
	{
		label: 'Music instruments from 20,00€',
		description: 'From 20,00€',
		type: 'extra',
		price: 20,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'Choose', route: 'ancillaries--music-instruments' },
		icon: 'luggage--music_equipment',
		name: 'Music instruments',
		id: 'instruments'
	},
	{
		label: 'Small pets from 35,00€',
		description: 'From 35,00€',
		type: 'extra',
		price: 35,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'Choose', route: 'ancillaries--small-pets' },
		icon: 'luggage--small_pets',
		name: 'Small pets',
		id: 'pets'
	}
];
export const DISCOUNT_FEATURES = [
	{
		label: 'Miles',
		order: 1,
		description: 'For Miles&GO members only',
		type: 'added',
		details: { label: 'Learn more', route: 'details-loyalty_miles' },
		icon: 'loyalty--miles',
		flight_details: { label: 'Learn more', route: 'flight-details-miles' },
		id: 'miles'
	},
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { type: 'available', price: 35 }),
	{
		label: 'Seat reservation',
		order: 4,
		description: '12B',
		id: 'seats',
		type: 'available',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' },
		icon: 'plane_related--seat',
		price: 35
	},{
		label: 'Corporate balance',
		order: 0,
		description: 'Corporate balance',
		type: 'unavailable',
		icon: 'corporate--corporate',
		details: { label: 'Learn more', route: 'corp-balance' },
		flight_details: { label: 'Learn more', route: 'corp-balance' },
		id: 'corpbalance'
	},
	{
		id: 'meals',
		label: 'Meal',
		order: 5,
		description: 'Meal not included',
		type: 'unavailable',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-snacks' },
		icon: 'food_drinks--cold_meals'
	},
	{
		label: 'Premium Boarding',
		type: 'unavailable',
		order: 6,
		details: { label: 'Learn more', route: 'premium-boarding' },
		icon: 'airport--differentiated_boarding',
		flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
		id: 'differentiated-boarding'
	},
	{
		label: 'Fast track',
		icon: 'plane_related--fast_track',
		type: 'available',
		description: 'All passengers can get faster through security',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		id: 'fasttrack',
		order: 7,
		price: 12
	},
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'unavailable',
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Choose a seating area from 12,00€',
		description: 'Seats from 12€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'plane_related--seat',
		action: { label: 'Choose', route: 'seatmap' },
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 12,00€',
		description: 'from 22€',
		type: 'extra',
		price: 22,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'ancillaries--luggage',
		action: { label: 'add', route: 'checked-bags' },
		name: 'Checked bags',
		id: 'bags'
	},
	{
		label: 'Fast track from 12,00€',
		description: 'from 12€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: true,
		icon: 'plane_related--fast_track',
		action: { label: 'add', route: 'fast-track' },
		name: 'Fast track',
		id: 'fasttrack'
	},
	Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
	// ...NO_PREMIUM_FEATURES,
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'unavailable',
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	...ECONOMY_EXTRAS_SECONDARY_FEATURES
];
export const BASIC_FEATURES = [
	{
		label: 'Corporate balance',
		order: 0,
		description: 'Corporate balance',
		type: 'added',
		icon: 'corporate--corporate',
		details: { label: 'Learn more', route: 'corp-balance' },
		flight_details: { label: 'Learn more', route: 'corp-balance' },
		id: 'corpbalance'
	},{
		label: 'Miles',
		order: 1,
		description: 'For Miles&GO members only',
		type: 'added',
		icon: 'loyalty--miles',
		details: { label: 'Learn more', route: 'details-loyalty_miles' },
		flight_details: { label: 'Learn more', route: 'flight-details-miles' },
		id: 'miles'
	},
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
	{
		label: 'Seat reservation',
		order: 4,
		description: '12B',
		id: 'seats',
		type: 'available',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' },
		price: 35
	},
	{
		label: 'Meal',
		order: 5,
		description: 'May include dairy and other allergens',
		id: 'meals',
		type: 'unavailable',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
	},
	{
		label: 'Premium Boarding',
		type: 'unavailable',
		order: 6,
		details: { label: 'Learn more', route: 'premium-boarding' },
		icon: 'airport--differentiated_boarding',
		flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
		id: 'differentiated-boarding'
	},
	{
		label: 'Fast track',
		icon: 'plane_related--fast_track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 7,
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		type: 'available',
		price: 10
	},
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 100,
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Choose a seating area from 12,00€',
		description: 'Seats from 12€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'Choose', route: 'seatmap' },
		icon: 'plane_related--seat',
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 12,00€',
		description: 'from 12€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'add', route: 'checked-bags' },
		icon: 'ancillaries--luggage',
		name: 'Checked bags',
		id: 'bags'
	},
	{
		label: 'Fast track from 12,00€',
		description: 'from 12€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: true,
		action: { label: 'add', route: 'fast-track' },
		icon: 'plane_related--fast_track',
		name: 'Fast track',
		id: 'fasttrack'
	},
	Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
	// ...NO_PREMIUM_FEATURES,
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'unavailable',
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	...ECONOMY_EXTRAS_SECONDARY_FEATURES
];

export const CLASSIC_FEATURES = [
	{
		label: 'Corporate balance',
		order: 0,
		description: 'Corporate balance',
		type: 'added',
		icon: 'corporate--corporate',
		details: { label: 'Learn more', route: 'corp-balance' },
		flight_details: { label: 'Learn more', route: 'corp-balance' },
		id: 'corpbalance'
	},{
		label: 'Miles',
		order: 1,
		description: 'For Miles&GO members only',
		type: 'added',
		icon: 'loyalty--miles',
		details: { label: 'Learn more', route: 'details-loyalty_miles' },
		flight_details: { label: 'Learn more', route: 'flight-details-miles' },
		id: 'miles'
	},
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
	{
		label: 'Standard seat reservation',
		order: 4,
		description: 'Free seat reservation in standard area',
		id: 'seats',
		type: 'added',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' }
	},
	{
		label: 'Meal',
		order: 5,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-meals' }
	},
	{
		label: 'Premium Boarding',
		type: 'added',
		order: 6,
		details: { label: 'Learn more', route: 'premium-boarding' },
		icon: 'airport--differentiated_boarding',
		flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
		id: 'differentiated-boarding'
	},
	{
		label: 'Fast track',
		icon: 'plane_related--fast_track',
		type: 'available',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		price: 10
	},
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 35,
		id: 'changes',
		order: 9,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Choose a seating area',
		description: 'Seats from 0€',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'Choose', route: 'seatmap' },
		icon: 'plane_related--seat',
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 12,00€',
		description: 'from 20€',
		type: 'extra',
		price: 20,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'add', route: 'checked-bags' },
		icon: 'ancillaries--luggage',
		name: 'Checked bags',
		id: 'bags'
	},
	{
		label: 'Fast track from 12,00€',
		description: 'from 12€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: true,
		action: { label: 'add', route: 'fast-track' },
		icon: 'plane_related--fast_track',
		name: 'Fast track',
		id: 'fasttrack'
	},
	Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
	// ...NO_PREMIUM_FEATURES,
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'unavailable',
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	...ECONOMY_EXTRAS_SECONDARY_FEATURES
];

export const PLUS_FEATURES = [
	{
		label: 'Corporate balance',
		order: 0,
		description: 'Corporate balance',
		type: 'added',
		icon: 'corporate--corporate',
		details: { label: 'Learn more', route: 'corp-balance' },
		flight_details: { label: 'Learn more', route: 'corp-balance' },
		id: 'corpbalance'
	},{
		label: 'Miles',
		order: 1,
		description: 'For Miles&GO members only',
		type: 'added',
		icon: 'loyalty--miles',
		details: { label: 'Learn more', route: 'details-loyalty_miles' },
		flight_details: { label: 'Learn more', route: 'flight-details-miles' },
		id: 'miles'
	},
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
	{
		label: 'Free seat reservation',
		order: 4,
		description: 'In standard and preferred areas',
		id: 'seats',
		type: 'added',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' }
	},
	{
		label: 'Meal',
		order: 5,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-meals' }
	},
	PREMIUM_BOARDING,
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Free changes',
		description: 'Schedule or date changes allowed',
		type: 'added',
		icon: 'airport--changes',
		details: { label: 'Learn more', route: 'details-changes' },
		id: 'changes',
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Choose a seating area from 0€',
		description: 'Seats from 0€',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'Choose', route: 'seatmap' },
		icon: 'plane_related--seat',
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 20,00€',
		description: 'From 20,00€',
		type: 'extra',
		price: 20,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'add', route: 'checked-bags' },
		icon: 'ancillaries--luggage',
		name: 'Checked bags',
		id: 'bags'
	},
	{
		label: 'Fast track from 12,00€',
		description: 'from 12€',
		type: 'extra',
		price: 12,
		secondary: true,
		secondary_on_mobile: true,
		action: { label: 'add', route: 'fast-track' },
		icon: 'plane_related--fast_track',
		name: 'Fast track',
		id: 'fasttrack'
	},
	PRIORITY_BAGGAGE,
	// ...NO_PREMIUM_FEATURES,
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'available',
		price: 10,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	...ECONOMY_EXTRAS_SECONDARY_FEATURES
];

export const EXECUTIVE_FEATURES = [
	{
		label: 'Corporate balance',
		order: 0,
		description: 'Corporate balance',
		type: 'added',
		icon: 'corporate--corporate',
		details: { label: 'Learn more', route: 'corp-balance' },
		flight_details: { label: 'Learn more', route: 'corp-balance' },
		id: 'corpbalance'
	},{
		label: 'Miles',
		order: 1,
		description: 'For Miles&GO members only',
		type: 'added',
		icon: 'loyalty--miles',
		details: { label: 'Learn more', route: 'details-loyalty_miles' },
		flight_details: { label: 'Learn more', route: 'flight-details-miles' },
		id: 'miles'
	},
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
	PRIORITY_BAGGAGE,
	{
		label: 'Free seat reservation',
		description: 'In any area',
		id: 'seats',
		order: 4,
		type: 'added',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' }
	},
	{
		label: 'Meal',
		order: 5,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-meals' }
	},
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 6,
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Free changes',
		description: 'Schedule or date changes allowed',
		type: 'added',
		icon: 'airport--changes',
		details: { label: 'Learn more', route: 'details-changes' },
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Choose your onboard meal',
		description: 'Choose onboard menu',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'choose', route: 'ancillaries--special-meals' },
		icon: 'ancillaries--special_meals',
		name: 'meals',
		id: 'meals'
	},
	{
		label: 'Choose any seating area for free',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		description: 'Any seat free',
		action: { label: 'Choose', route: 'seatmap' },
		icon: 'plane_related--seat',
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 47,00€',
		description: 'From 47,00€',
		type: 'extra',
		price: 47,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'add', route: 'checked-bags' },
		icon: 'ancillaries--luggage',
		name: 'Checked bags',
		id: 'bags'
	},
	PREMIUM_CUSTOMER_CENTRE,
	PREMIUM_BOARDING,
	PRIORITY_CHECK_IN,
	{
		label: 'Refundable',
		type: 'available',
		icon: 'money_related--refund',
		price: 100,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	...BUSINESS_EXTRAS_SECONDARY_FEATURES
];

export const TOP_EXECUTIVE_FEATURES = [
	{
		label: 'Corporate balance',
		order: 0,
		description: 'Corporate balance',
		type: 'added',
		icon: 'corporate--corporate',
		details: { label: 'Learn more', route: 'corp-balance' },
		flight_details: { label: 'Learn more', route: 'corp-balance' },
		id: 'corpbalance'
	},{
		label: 'Miles',
		order: 1,
		description: 'For Miles&GO members only',
		type: 'added',
		icon: 'loyalty--miles',
		details: { label: 'Learn more', route: 'details-loyalty_miles' },
		flight_details: { label: 'Learn more', route: 'flight-details-miles' },
		id: 'miles'
	},
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
	PRIORITY_BAGGAGE,
	{
		label: 'Free seat reservation',
		description: 'In any area',
		id: 'seats',
		order: 4,
		type: 'added',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' }
	},
	{
		label: 'Meal',
		order: 5,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-meals' }
	},
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 6,
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Free changes',
		description: 'Schedule or date changes allowed',
		type: 'added',
		icon: 'airport--changes',
		details: { label: 'Learn more', route: 'details-changes' },
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Choose your onboard meal',
		description: 'Choose onboard menu',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'choose', route: 'ancillaries--special-meals' },
		icon: 'ancillaries--special_meals',
		name: 'meals',
		id: 'meals'
	},
	{
		label: 'Choose any seating area for free',
		description: 'Any seat free',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'Choose', route: 'seatmap' },
		icon: 'plane_related--seat',
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 47,00€',
		description: 'From 47,00€',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'add', route: 'checked-bags' },
		icon: 'ancillaries--luggage',
		name: 'Checked bags',
		id: 'bags'
	},
	PREMIUM_CUSTOMER_CENTRE,
	PREMIUM_BOARDING,
	PRIORITY_CHECK_IN,
	{
		label: 'Refundable',
		type: 'added',
		details: { label: 'Learn more', route: 'details-refunds' },
		icon: 'money_related--refund',
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	...BUSINESS_EXTRAS_SECONDARY_FEATURES
];

export const TAP_MILES_GO_ECONOMY = [
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
	{
		label: 'Standard seat reservation',
		order: 4,
		description: 'Free seat reservation in standard area',
		id: 'seats',
		type: 'added',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' }
	},
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 5,
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		id: 'meals',
		label: 'Meal',
		order: 6,
		description: 'Meal not included',
		type: 'unavailable',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-snacks' },
		icon: 'food_drinks--cold_meals'
	},
	Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 100,
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'available',
		price: 10,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	{
		label: 'Choose a seating area from 12,00€',
		description: 'Seats from 12€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'plane_related--seat',
		action: { label: 'Choose', route: 'seatmap' },
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 12,00€',
		description: 'from 22€',
		type: 'extra',
		price: 22,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'ancillaries--luggage',
		action: { label: 'add', route: 'checked-bags' },
		name: 'Checked bags',
		id: 'bags'
	},
	...ECONOMY_EXTRAS_SECONDARY_FEATURES
];

export const TAP_MILES_GO_ECONOMY_EXTRA = [
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
	{
		label: 'Free economyXtra seat',
		order: 4,
		description: 'Free seat reservation in economyXtra area',
		id: 'seats',
		type: 'added',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' }
	},
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 5,
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Meal',
		order: 6,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-meals' }
	},
	Object.assign({}, PRIORITY_BAGGAGE, { type: 'unavailable' }),
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 100,
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'available',
		price: 10,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	{
		label: 'Choose a seating area from 0€',
		description: 'Seats from 0€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'plane_related--seat',
		action: { label: 'Choose', route: 'seatmap' },
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Extra bags from 12,00€',
		description: 'from 22€',
		type: 'extra',
		price: 22,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'ancillaries--luggage',
		action: { label: 'add', route: 'checked-bags' },
		name: 'Checked bags',
		id: 'bags'
	},
	...ECONOMY_EXTRAS_SECONDARY_FEATURES
];

export const TAP_MILES_GO_EXECUTIVE = [
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
	{
		label: 'Free seat reservation',
		order: 4,
		description: 'In standard and preferred areas',
		id: 'seats',
		type: 'added',
		icon: 'plane_related--seat',
		details: { label: 'Learn more', route: 'details-seat' },
		flight_details: { label: 'Learn more', route: 'flight-details-seat' }
	},
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 5,
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Meal',
		order: 6,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-meals' }
	},
	PRIORITY_BAGGAGE,
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 100,
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'available',
		price: 10,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	{
		label: 'Choose any seating area for free',
		description: 'Seats from 0€',
		type: 'extra',
		price: 12,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'plane_related--seat',
		action: { label: 'Choose', route: 'seatmap' },
		name: 'Seats',
		id: 'seats'
	},
	{
		label: 'Choose your onboard meal',
		description: 'Choose onboard menu',
		type: 'extra',
		price: 0,
		secondary: false,
		secondary_on_mobile: false,
		action: { label: 'choose', route: 'ancillaries--special-meals' },
		icon: 'ancillaries--special_meals',
		name: 'meals',
		id: 'meals'
	},
	{
		label: 'Extra bags from 12,00€',
		description: 'from 22€',
		type: 'extra',
		price: 22,
		secondary: false,
		secondary_on_mobile: false,
		icon: 'ancillaries--luggage',
		action: { label: 'add', route: 'checked-bags' },
		name: 'Checked bags',
		id: 'bags'
	},
	...BUSINESS_EXTRAS_SECONDARY_FEATURES
];

export const STAR_ALLIANCE_ECONOMY = [
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
	{
		label: 'Fast track',
		id: 'fasttrack',
		order: 7,
		type: 'unavailable',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 100,
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'available',
		price: 10,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	{
		label: 'Meal',
		order: 5,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
	},
];

export const STAR_ALLIANCE_BUSINESS = [
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 1 }),
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 7,
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 100,
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'available',
		price: 10,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	{
		label: 'Business Meal',
		order: 5,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
	},
];

export const STAR_ALLIANCE_FIRST = [
	HAND_BAGGAGE,
	Object.assign({}, CHECKED_BAGGAGE, { amount: 2 }),
	{
		label: 'Fast track',
		description: 'All passengers can get faster through security',
		id: 'fasttrack',
		order: 7,
		type: 'added',
		flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
		icon: 'plane_related--fast_track',
		details: { label: 'Learn more', route: 'details-fast_track' }
	},
	{
		label: 'Changes',
		icon: 'airport--changes',
		type: 'available',
		price: 100,
		id: 'changes',
		order: 8,
		flight_details: { label: 'Learn more', route: 'flight-details-changes' },
	},
	{
		label: 'Refundable',
		icon: 'money_related--refund',
		type: 'available',
		price: 10,
		id: 'refunds',
		order: 99,
		flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
	},
	{
		label: 'First Class Meal',
		order: 5,
		description: 'For free. May include dairy and other allergens',
		id: 'meals',
		type: 'added',
		icon: 'food_drinks--cold_meals',
		details: { label: 'Learn more', route: 'details-snacks' },
		flight_details: { label: 'Learn more', route: 'flight-details-snacks' }
	},
];

export const getBrands = (options = { brands: false }) => {
	const brandsList = [
		{
			label: 'Economy',
			label_sufix: 'from',
			brands: [
				{ name: 'discount' },
				{ name: 'basic' },
				{ name: 'classic' },
				{ name: 'plus' }
			]
		},
		{
			label: 'Business',
			label_sufix: 'from',
			brands: [
				{ name: 'executive' },
				{ name: 'top-executive' }
			]
		},
		{
			label: 'Economy/Executive',
			label_sufix: 'from',
			brands: [
				{ name: 'milesgo-economy' },
				{ name: 'miles&go-extra' },
				{ name: 'miles&go-executive' }
			]
		},
		{
			label: 'Economy/Business',
			label_sufix: 'from',
			brands: [
				{ name: 'star_alliance-economy' },
				{ name: 'star_alliance-business' },
				{ name: 'star_alliance-first' }
			]
		}
	];

	if (options.brands) {
		return brandsList.reduce((acc, cur) => { cur.brands.map(c => acc.push(c.name)); return acc; }, []);
	}

	return brandsList;
};

export const getBrandFeaturesCorp = (brand, options = { NO_PREMIUM_FEATURES: false }, order = true) => {
	// return this.EXAMPLE_FEATURES;
	let featureList = [];
	brand = brand ? brand.toLowerCase() : '';
	switch (brand) {
		case 'discount':
			featureList = !options.NO_PREMIUM_FEATURES ? DISCOUNT_FEATURES : [].concat(DISCOUNT_FEATURES, NO_PREMIUM_FEATURES);
			break;
		case 'basic':
			featureList = !options.NO_PREMIUM_FEATURES ? BASIC_FEATURES : [].concat(BASIC_FEATURES, NO_PREMIUM_FEATURES);
			break;
		case 'classic':
			featureList = !options.NO_PREMIUM_FEATURES ? CLASSIC_FEATURES : [].concat(CLASSIC_FEATURES, NO_PREMIUM_FEATURES);
			break;
		case 'plus':
			featureList = !options.NO_PREMIUM_FEATURES ? PLUS_FEATURES : [].concat(PLUS_FEATURES, NO_PREMIUM_FEATURES);
			break;
		case 'executive':
			featureList = EXECUTIVE_FEATURES;
			break;
		case 'top-executive':
			featureList = TOP_EXECUTIVE_FEATURES;
			break;
		case 'miles&go-economy':
			featureList = TAP_MILES_GO_ECONOMY;
			break;
		case 'miles&go-extra':
			featureList = TAP_MILES_GO_ECONOMY_EXTRA;
			break;
		case 'miles&go-executive':
			featureList = TAP_MILES_GO_EXECUTIVE;
			break;
		case 'star_alliance-economy':
			featureList = STAR_ALLIANCE_ECONOMY;
			break;
		case 'star_alliance-business':
			featureList = STAR_ALLIANCE_BUSINESS;
			break;
		case 'star_alliance-first':
			featureList = STAR_ALLIANCE_FIRST;
			break;
		default:
			featureList = DEFAULT_FEATURES;
			break;
	}

	if (order) {
		featureList = featureList.slice().sort((a, b) => a.order && b.order && parseFloat(a.order) - parseFloat(b.order));
	}

	return featureList;
};

